// import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const ContainerFluid = styled.div`
// border:2px dashed red;
width:100%;
min-height:700px;
b
`;
export const ContainerFluidX = styled.div`
margin-top:-200px;
// border:2px dashed red;
width:100%;
min-height:300px;
background-image:url('https://res.cloudinary.com/yalla-ng/image/upload/v1657191173/Group_2_xq0iah.svg');
background-size:contain;
background-repeat:no-repeat;
background-position:bottom right;
`;
export const ContainerFluidY = styled.div`
// border:2px dashed red;
width:100%;
min-height:500px;
background-image:url('https://res.cloudinary.com/yalla-ng/image/upload/v1657191328/Group_3_fndgfk.svg');
background-size:contain;
background-repeat:no-repeat;
background-position:left;
margin-bottom:-300px;
`;


export const Container = styled.div
.attrs(() => ({
  className: 'container-custom',
}))`
min-height: 396px;
`;
export const ContainerX = styled.div
.attrs(() => ({
  className: 'container-custom',
}))`
height: 534px;
width:75% !important;
background: linear-gradient(113.57deg, rgba(0, 165, 104, 0.5) 22.35%, rgba(0, 165, 104, 0.2) 71.76%);
border-radius: 40px;
@media screen and (max-width: 425px) {
    width:98% !important;
    height: 484px;
}
  
`;


export const HeadingText = styled.h1
.attrs(() => ({
  className: '',
}))`
// width: 359px;
min-height: 38px;
font-family: 'Cabinet Grotesk-bold';
font-style: normal;
font-weight: 800;
font-size: 40px;
line-height: 103%;
color: #282828;
margin-bottom:0px !important;
@media screen and (max-width: 425px) {
    width:auto !important;
}

`;



export const DescText = styled.p
.attrs(() => ({
  className: '',
}))`
font-family: 'Cabinet Grotesk-regular', roboto;
font-style: normal;
font-weight: 800;
font-size:20px;
line-height: 142.5%;
color: #4A4A4A;
b{
font-family: 'Cabinet Grotesk-b', roboto;
font-weight: 500;
}
@media screen and (max-width: 425px) {
    width:auto !important;
}
`;